
import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';
import { ORGANIZACION, SEDES } from '../data/organizacion';
import { breadcrumb } from '../data/schema';

const Contacto = () => {
  return (
    <div className="container">
      <SEO
        title="Contacto — Mi Lugar CET y Centro de Día Zona Sur"
        description={`Contactanos por WhatsApp, teléfono o email. Sedes en ${SEDES.map((s) => `${s.nombreCorto.replace('Sede ', '')} (${s.calle})`).join(' y ')}. ${ORGANIZACION.horarioTexto}.`}
        path="/contacto"
        jsonLd={[
          breadcrumb([{ nombre: 'Contacto', path: '/contacto' }]),
          {
            '@type': 'ContactPage',
            name: 'Contacto — Mi Lugar',
            description: `Datos de contacto de las sedes de Mi Lugar. ${ORGANIZACION.horarioTexto}.`,
            mainEntity: SEDES.map((s) => ({ '@id': s.id })),
          },
        ]}
      />
      <div className="sede-header">
        <h1>Contacto</h1>
        <p>Estamos aquí para responder tus preguntas y brindarte toda la información que necesites sobre nuestros servicios.</p>
      </div>

      <section className="contact-section" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', marginBottom: '50px' }}>
        <div>
          <h2>Información de contacto</h2>
          <p>Podés comunicarte con nosotros {ORGANIZACION.horarioTexto.toLowerCase()} a través de cualquiera de los siguientes medios:</p>

          <div className="contact-info" style={{ marginTop: '20px' }}>
            <div className="contact-item" style={{ marginBottom: '15px' }}>
              <FaEnvelope className="contact-icon" />
              <a href={`mailto:${ORGANIZACION.email}`}>{ORGANIZACION.email}</a>
            </div>

            {SEDES.map((sede) => (
              <React.Fragment key={sede.slug}>
                <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>{sede.nombreCorto}</h3>
                <div className="contact-item" style={{ marginBottom: '15px' }}>
                  <FaMapMarkerAlt className="contact-icon" />
                  <span>{sede.direccionCompleta}</span>
                </div>
                <div className="contact-item" style={{ marginBottom: '15px' }}>
                  <FaPhone className="contact-icon" />
                  <a href={`tel:${sede.telefono}`}>{sede.telefonoTexto}</a>
                </div>
                <div className="contact-item" style={{ marginBottom: '15px' }}>
                  <FaWhatsapp className="contact-icon" />
                  <a href={sede.whatsapp} target="_blank" rel="noopener noreferrer">
                    WhatsApp: {sede.telefonoTexto}
                  </a>
                </div>
              </React.Fragment>
            ))}

            <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Síguenos en redes sociales</h3>
            <div style={{ display: 'flex', gap: '15px' }}>
              <a href="https://www.facebook.com/MiLugarTemperley" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/cet.milugar/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <h2 className="section-title">Nuestras Sedes</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          <div className="map-container">
            <h3>Sede Temperley</h3>
            <p>A. Gallardo 646, Provincia de Buenos Aires</p>
            <div style={{ marginTop: '15px', height: '300px' }}>
              <iframe 
                src="https://maps.google.com/maps?q=A.+Gallardo+646,+Temperley,+Buenos+Aires&hl=es&z=16&output=embed"
                width="100%" 
                height="100%" 
                style={{ border: 0, borderRadius: '8px' }} 
                allowFullScreen="" 
                loading="lazy"
                title="Mapa Sede Temperley"
              ></iframe>
            </div>
          </div>

          <div className="map-container">
            <h3>Sede Glew</h3>
            <p>Av. Hipólito Yrigoyen 22548, B1856 Guernica, Provincia de Buenos Aires</p>
            <div style={{ marginTop: '15px', height: '300px' }}>
              <iframe 
                src="https://maps.google.com/maps?q=Av.+Hip%C3%B3lito+Yrigoyen+22548,+Guernica,+Buenos+Aires&hl=es&z=16&output=embed"
                width="100%" 
                height="100%" 
                style={{ border: 0, borderRadius: '8px' }} 
                allowFullScreen="" 
                loading="lazy"
                title="Mapa Sede Glew"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a href={SEDES[0].whatsapp} className="whatsapp-float" target="_blank" rel="noopener noreferrer" aria-label="Escribinos por WhatsApp">
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default Contacto;
